import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ToolListService } from '@/shared/services/tool-list.service';

@Component({
  selector: 'app-advisor-identified-at-risk-help-page',
  templateUrl: './advisor-identified-at-risk-help-page.component.html',
  styleUrls: ['./advisor-identified-at-risk-help-page.component.css'],
  standalone: false,
})
export class AdvisorIdentifiedAtRiskHelpPageComponent {
  public env = environment;

  constructor(public toolListService: ToolListService) {}
}
